import { render, staticRenderFns } from "./NewFolderModal.vue?vue&type=template&id=495f29f0"
import script from "./NewFolderModal.vue?vue&type=script&lang=ts"
export * from "./NewFolderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495f29f0')) {
      api.createRecord('495f29f0', component.options)
    } else {
      api.reload('495f29f0', component.options)
    }
    module.hot.accept("./NewFolderModal.vue?vue&type=template&id=495f29f0", function () {
      api.rerender('495f29f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/NewFolderModal.vue"
export default component.exports